const FULFILMENT_PASS_USER_LOADED = 'FULFILMENT_PASS_USER_LOADED'

export { FULFILMENT_PASS_USER_LOADED }
